import MarketingUrlService from "@services/marketingUrls.service";
import {AppResourceSearch, ApiFilter} from '@sellers-shield-home-protection/ss-core-js';
import {isEmpty} from "lodash";
import {getActiveThirdPartyPlatformList, runAsPublic} from "@helpers/api-helper";
import {mapActions, mapState} from 'pinia';
import {useAuthStore} from '@store';
import {isValidEmail} from "@helpers/email";
import {fetchEnabledStates} from "@helpers/state";
import {debugf, isNumber} from "@helpers/string";
import UserChecksMixin from "@mixins/UserChecksMixin";
import {pageRedirect} from "@helpers/router-helper";
import FrontEndApiService from "@services/frontend.api.service";
import { ALL } from '@sellers-shield-home-protection/ss-core-js/src/AppResources/LuAccountTypeAppResource';


export default {
    mixins: [
        UserChecksMixin,
    ],
    data: () => ({
        isSetupDone: true,
        activeStep: null,
        userUuid: null,
        loading: false,
        marketingDataSaved: false,
        params: {},
        userExists: false,
        passwordNotSet: true,
        userUuid: null,
        credentials: {
            email: '',
            password: '',
        },
        basicInfo: {
            accountType: '',
        },
        state: {
            state: '',
        },
        errors: {
            email: [],
            state: [],
            password: [],
            confirmPassword:[]
        },
        referringPlatformAppResource: {},
        STEPS_GROUPS: {
            default: []
        },
    }),

    computed: {
        ...mapState(useAuthStore, {
            me: 'me',
            thirdPartyUuid: 'thirdPartyUuid',
            meHasValidTxLicense: 'meHasValidTxLicense',
        }),
    },

    methods: {
        ...mapActions(useAuthStore, {
            login: 'login',
        }),
        clearErrors() {
            Object.keys(this.errors).forEach(key => this.errors[key] = []);
        },

        getNavigationSteps() {
            return (this.STEPS_GROUPS || {}).default || [];
        },
        handleNavigation() {
            let STEP_LIST = this.getNavigationSteps(),
                currentStepIndex = STEP_LIST.indexOf(this.activeStep),
                lastStep = STEP_LIST[currentStepIndex - 1] || null;

            if (
                lastStep === 'signIn' && !this.userExists
            ) {
                lastStep = STEP_LIST[currentStepIndex - 2];
                --currentStepIndex;
            }
            debugf(`handledNavigation - ${this.activeStep}`, {lastStep, currentStepIndex, STEP_LIST});
            //if lastStep is null we redirect to guest auth
            this.backTo(lastStep, false);
        },
        getStepFromNavigationFlowByIndex(index = 0, defaultStep = null) {
            let STEP_LIST = this.getNavigationSteps();
            return (STEP_LIST ? STEP_LIST[index] : null) || defaultStep;
        },
        activeStepByNavFlow(step, setValue = true, defaultToStep = null) {
            let isValid = false;

            if (step) {
                let STEP_LIST = this.getNavigationSteps();

                Boolean(STEP_LIST)
                && this.loadingWrapper(() => {
                    if (STEP_LIST.includes(step)) {
                        setValue && (this.activeStep = step);
                        isValid = true;
                    } else if (setValue && Boolean(defaultToStep)) {
                        this.activeStep = this.getStepFromNavigationFlowByIndex(0, defaultToStep);
                        isValid = true;
                    }
                }, setValue);
            }

            return isValid;
        },
        backTo(step, clearEmail = true) {
            this.activeStepByNavFlow(step) || this.backToEmail(clearEmail);
        },
        backToEmail(clearEmail = true) {
            this.clearErrors();
            this.credentials = {
                email: clearEmail ? '' : this.credentials?.email,
                password: '',
            };
            let STEP_LIST = this.getNavigationSteps();
            let firstStepKey = Object.keys(STEP_LIST || {})[0] || null;
            firstStepKey && this.activeStepByNavFlow(firstStepKey, true, firstStepKey);
        },

        async searchExistingUser(email) {
            this.clearErrors();
            return await this.checkUserExists(
                email,
                async (data) => {
                    
                    this.passwordNotSet = Boolean(data?.account_unfinished);
                    this.userUuid = data?.user_uuid;
                    if(data?.account_type_id){
                        this.basicInfo.accountType = data?.account_type_id;
                        if (data?.account_type_id === ALL.AGENT){
                            this.basicInfo.accountType = "agent"
                        }
                    }
                    !Boolean(data?.status) || await this.doMarketingRecording('', email)
                },
                async (response) => {
                    let data = response.data || {};
                    switch (response?.status) {
                        case 302:
                            Boolean(data?.redirect) && await pageRedirect(data.redirect);
                            return false;
                    }
                }
            );
        },
        async resetPassword(password){
            return await runAsPublic(async (config) => {
                const resetPasswordData = {
                    password
                };

                const response = await FrontEndApiService.put(`${config.apiPrefix}/v1/user/` + this.userUuid, resetPasswordData);

                if (response.status !== 200) {
                    console.warn("Error submitting password", error);
                    this.errors.password.push('Token not found or is expired');
                    throw "Token not found or is expired";
                }
            });
        },
        paramStringFromUrl(url) {
            return url ? (`${url}`.split('?')[1] || '') : ''
        },
        getMarketingSearchParams(urlString = '') {
            let regexDomain = new RegExp('^(?:https?:\/\/(?:www.)?)?sellersshield.com', 'g'),
                searchString = this.paramStringFromUrl(
                    regexDomain.test(document.referrer) && document.referrer.indexOf('utm_source') > -1
                        ? document.referrer
                        : urlString
                ) || window.location.search;
            return new URLSearchParams(searchString);
        },
        async doMarketingRecording(urlString = '', emailRewrite = null, force = false) {
            let params = this.getMarketingSearchParams(urlString),
                hasEmail = Boolean(params.get('email_address') || params.get('vyemail') || params.get('email'));

            if (!hasEmail && !!emailRewrite) {
                params.set('email', emailRewrite);
                hasEmail = true;
            }

            this.marketingDataSaved || !force && !hasEmail || (
                this.marketingDataSaved = await MarketingUrlService.createMarketingUrl(
                    params,
                    this.userExists ? 'login' : 'signup',
                    urlString || window.location.href,
                )
            );
        },

        async checkAppVersionByEmailState(email, state, redirectTo, data = {}) {
            return await this.checkUserAppVersion(
                email, state, redirectTo,
                data = {},
                async (response, redirectTo) => {
                    let data = response?.data || {};

                    if (data.shouldRedirect && data.redirectUrl) {
                        let params = this.getMarketingSearchParams(redirectTo),
                            redirectUrl = data.redirectUrl,
                            paramsRedirectUrl = new URLSearchParams(this.paramStringFromUrl(redirectUrl));

                        paramsRedirectUrl.forEach((val, key) => Boolean(val) && params.has(key) && params.delete(key));

                        redirectUrl += (redirectUrl.indexOf('?') > -1 ? '&' : '?') + params.toString();

                        this.marketingDataSaved = true;

                        await pageRedirect(redirectUrl);
                    }
                },
            );
        },

        async checkEmail(email) {
            this.clearErrors();
            return email && isValidEmail(email);
        },
        async setUserData(data) {
            delete data.stateId;
        },
        async getLuState(stateValue) {
            let state = null;
            await runAsPublic(async () => {
                const searchKey = isNumber(stateValue) ? 'id' : ([...stateValue].length < 4 ? 'slug' : 'title');
                const appResourceSearch = new AppResourceSearch('lu-state');

                await appResourceSearch.setSearchData({
                    pageSize: 1,
                    filter: new ApiFilter({
                        params: {
                            [searchKey]: stateValue,
                        },
                    }),
                }, false);

                await appResourceSearch.search();
                [state] = appResourceSearch.appResourceCollection.toArray();
            });

            return state;
        },

        async checkUserData(data, checkState = true, checkUserExist = true) {
            this.loading = true;

            if (!checkUserExist || await this.checkEmail(data?.email)) {
                this.credentials.email = data?.email || this.credentials?.email;
            }

            if (!isEmpty(data?.state) && checkState) {
                const state = await this.getLuState(data.state);
                isEmpty(state) || (data.stateId = state.id);
            }

            this.$nextTick(() => this.loading = false);

            return await this.setUserData(data);
        },


        async setStateMeta(state, properties) {
            let property = null,
                stateMeta = null,
                dataStates = await runAsPublic(async () => (await fetchEnabledStates()).toArray());

            for (const i in properties) {
                property = properties[i];
                if (property) {
                    stateMeta = (dataStates.find(item => item[`${property}`] === state) || {}).meta;
                    if (stateMeta) {
                        this.stateMeta = JSON.parse(stateMeta);
                        return true;
                    }
                }
            }

            return false;
        },

        async getReferringPlatformAppResource() {
            this.referringPlatformAppResource = this.thirdPartyUuid
                ? (await getActiveThirdPartyPlatformList()).find(p => [p?.uuid, p?._uuid].includes(this.thirdPartyUuid)) || {}
                : {};
        },

        async loadingWrapper(callback, trigger = true) {
            trigger && this.isSetupDone && (this.loading = true);
            let retValue = await callback();
            trigger && this.isSetupDone && this.$nextTick(() => this.loading = false);
            return retValue;
        },
        async setupWrapper(callback) {
            this.isSetupDone = false;
            let retValue = await callback();
            this.$nextTick(() => this.isSetupDone = true);
            return retValue;
        }
    },

    async beforeMount() {
        await this.getReferringPlatformAppResource();
    },
    async beforeDestroy() {
        await this.doMarketingRecording(this.params?.redirectUrl, this.credentials?.email, true);
    }
};
